import { PublicationShortname } from "@src/app/auth/serviceIdentifier";
import cx from "classnames";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "../Modal";
import styles from "./index.module.scss";

type Props = {
  theme: PublicationShortname | null;
  onClose: () => void;
  onSubscribe: () => void;
};

/**
 * Modal shown when a preview (non-subscriber) user taps the archive or calendar
 * icon on the Index (EPPR2-3142). Gate is UI-level only. Design: Figma
 * "E-Paper Preview Pilot with TM — Website" (ePaper Modal).
 */
export default function PreviewGateModal({
  theme,
  onClose,
  onSubscribe,
}: Props): ReactElement {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose}>
      <div className={cx(styles.gate)} data-theme={theme ?? undefined}>
        <h2 className={cx(styles.title)}>{t("home:preview.gate.title")}</h2>
        <p className={cx(styles.body)}>{t("home:preview.gate.body")}</p>
        <button className={cx(styles.cta)} onClick={onSubscribe}>
          {t("home:preview.gate.cta")}
        </button>
      </div>
    </Modal>
  );
}
